/* src/services/ResourcesService.js */
import apiClient from './api' // Usa l'istanza configurata

export const ResourcesService = {
  
  mapCategoryFromApi(data) {

    return {
      id: data.id,
      name: data.name || '',
      description: data.description || ''
    }
  },

  mapCategoryToApi(category) {

    return {
      name: category.name,
      description: category.description
    }
  },

  async getAllCategories() {

    try {

      const response = await apiClient.get('booking/resource-categories/')

      if (!Array.isArray(response.data)) return []

      return response.data.map(item => this.mapCategoryFromApi(item))
    } 
    catch (error) {
    
      console.error("Errore nel recupero categorie:", error)
      throw error
    }
  },

  async createCategory(category) {
    
    const payload = this.mapCategoryToApi(category)
    const response = await apiClient.post('booking/resource-categories/', payload)
    return this.mapCategoryFromApi(response.data)
  },

  async updateCategory(id, category) {
    
    const payload = this.mapCategoryToApi(category)
    const response = await apiClient.put(`booking/resource-categories/${id}/`, payload)
    return this.mapCategoryFromApi(response.data)
  },

  async deleteCategory(id) {
    
    return await apiClient.delete(`booking/resource-categories/${id}/`)
  },

  mapResourceFromApi(data) {
    return {
      id: data.id,
      name: data.name || '',
      categoryId: data.category || null,
      quantity: data.capacity ?? 1,
      minStock: data.min_stock_level ?? 0, // Nuovo campo
      isLowStock: data.is_low_stock ?? false, // Stato pronto all'uso per Vue
      isAvailable: data.is_available ?? true,
      notes: data.notes || ''
    }
  },
  
  mapResourceToApi(resource) {
    return {
      name: resource.name,
      category: resource.categoryId,
      capacity: resource.quantity,
      min_stock_level: resource.minStock, // Nuovo campo
      is_available: resource.isAvailable,
      notes: resource.notes
    }
  },

  async getAllResources() {
  
    try {
  
      const response = await apiClient.get('resources/resources/') 
  
      if (!Array.isArray(response.data)) return []
  
      return response.data.map(item => this.mapResourceFromApi(item))
    } 
    catch (error) {
    
      console.error("Errore fetch risorse:", error)
      throw error
    }
  },

  async createResource(resource) {
    
    const payload = this.mapResourceToApi(resource)
    const response = await apiClient.post('resources/list/', payload)
    return this.mapResourceFromApi(response.data)
  },

  async updateResource(id, resource) {
  
    const payload = this.mapResourceToApi(resource)
    const response = await apiClient.put(`resources/resources/${id}/`, payload)
  
    return this.mapResourceFromApi(response.data)
  },

  async deleteResource(id) {
    
    return await apiClient.delete(`resources/list/${id}/`)
  }
}